export enum TipoCadastro {
    TODOS = 'TODOS',
    CLIENTES = 'CLIENTES',
    FORNECEDORES = 'FORNECEDORES',
    PRODUTORES = 'PRODUTORES',
    SINDICATO = 'SINDICATO',
    PONTO_ATENDIMENTO = 'PONTO_ATENDIMENTO',
    VENDEDORES = 'VENDEDORES',
    TRANSPORTADORES = 'TRANSPORTADORES',
    MOTORISTAS = 'MOTORISTAS',
    FUNCIONARIOS = 'FUNCIONARIOS',
    TECNICOS = 'TECNICOS',
    TRABALHADORES = 'TRABALHADORES',
}
